// src/pages/SearchPage.js
import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import BookCard from '../components/BookCard';
import { Link } from 'react-router-dom';
import { fetchSearchCandidates } from '../utils/searchBooks';

export default function SearchPage() {
  const [params] = useSearchParams();
  const qParam = (params.get('q') || '').trim().toLowerCase();

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const reqKeyRef = useRef(0);

  useEffect(() => {
    let cancelled = false;
    const myKey = ++reqKeyRef.current;

    async function run() {
      const qText = qParam;
      if (qText.length < 2) {
        setResults([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const take = 50;
        const rawRows = await fetchSearchCandidates(qText, { take, minQueryLength: 2 });
        if (cancelled || reqKeyRef.current !== myKey) return;
        const combined = Array.isArray(rawRows) ? rawRows : [];

        // ключ книги: спершу нормалізований ISBN; якщо його нема — title+author
        const keyOf = (b) => {
          const isbn = (b.isbn || b.ISBN || b.isbn13 || '')
            .replace(/[^0-9A-Za-z]/g, '')
            .toLowerCase();
          if (isbn) return `isbn:${isbn}`;
          const t = (b.title || b.name || '').toLowerCase().trim();
          const a = (b.author || (b.authors?.join(', ') || '')).toLowerCase().trim();
          return `ta:${t}__${a}`;
        };

        // якщо одна й та ж книга є і в bookTemplates, і в books — лишаємо варіант із books
        const map = new Map();
        for (const it of combined) {
          const k = keyOf(it);
          const prev = map.get(k);
          if (!prev || prev.__col === 'bookTemplates') {
            map.set(k, it); // пріоритет реальному екземпляру
          }
        }
        let arr = Array.from(map.values());


        // легке сортування за назвою
        arr.sort((a, b) =>
          ((a.title || a.name || '').toLowerCase())
            .localeCompare((b.title || b.name || '').toLowerCase())
        );

        if (!cancelled && reqKeyRef.current === myKey) setResults(arr);
      } finally {
        if (!cancelled && reqKeyRef.current === myKey) setLoading(false);
      }
    }

    run();
    return () => { cancelled = true; };
  }, [qParam]);

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ marginBottom: 12 }}>
        Результати пошуку{qParam ? `: “${qParam}”` : ''}
      </h2>

      {loading && <p>Завантаження…</p>}
      {!loading && !results.length && (
        <p>Нічого не знайдено. Спробуйте інший запит.</p>
      )}

      {!!results.length && (
        <div
          style={{
            display: 'grid',
            // адаптивна сітка: нормою 4 у ряд при достатній ширині,
            // при звуженні — автоматично 3/2/1 без перекриття
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: 20
          }}

        >
          {results.map(b => {
            const isbn = b.isbn || b.ISBN || b.isbn13 || b.id;
            return (
              <Link
                key={`${b.__col}-${b.id}`}
                to={`/book/${encodeURIComponent(isbn)}`}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <BookCard book={b} />
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
